var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.accordion = {
	getOpenOffset: function() {
		return 80;
	},
	shouldAddHashes: true,
	shouldUpdateHash: true,
	shouldFollowHash: true,
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		/*$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});*/

		$('.icon.svg').each(function() {
			let icon = $(this).data('icon');
			if (icon && icon.length) {
				let style = "url('/static/files/icons/" + icon + ".svg') no-repeat center / contain;";
				$(this).attr('style', "-webkit-mask: " + style + "mask: " + style);
			}
		});
	}
};

site.boxman = {
	init: function () {
		$("#dialog").on("dialogopen", function (event, ui) {
			site.boxman.waitUntil(function () {
				return $('#title', '.boxmanBoxForm').length > 0;
			}, function () {
				site.multiform.admin();
			}, function () {
			});
		});
	},
	waitUntil: function (isready, success, error, count, interval) {
		if (count === undefined) {
			count = 100;
		}
		if (interval === undefined) {
			interval = 20;
		}
		if (isready()) {
			success();
			return;
		}
		// The call back isn't ready. We need to wait for it
		setTimeout(function () {
			if (!count) {
				// We have run out of retries
				if (error !== undefined) {
					error();
				}
			} else {
				// Try again
				site.boxman.waitUntil(isready, success, error, count - 1, interval);
			}
		}, interval);
	}
};

site.sponsors = {
	init:function() {
		var $owl = $('#brands ul');
		if (!$owl) return false;

		site.owl.init('#brands ul', {
			loop: false,
			dots: false,
			nav: true,
			items: 1,
			slideBy: 1,
			navText: ["", ""],
			responsive: {
				1080 : {
					items: 4
				},
				880 : {
					items: 3
				},
				630 : {
					items: 2
				},
				0: {
					items: 1
				}
			}
		});
	}
};
site.inits.push('site.sponsors.init()');

site.frontpage = {
	init: function() {
		var $carousel = $('#main .ummaeli');
		if($carousel) {
			site.owl.init($carousel.find('.items'), {
				loop: false,
				nav:true,
				navText:["<i class=\"fa fa-angle-left\"></i>","<i class=\"fa fa-angle-right\"></i>"],
				dots: false,
				autoplay:false,
				smartSpeed:700,
				items: 1
			});
		}

		site.owl.init('.social__carousel', {
			items: 1,
			loop: false,
			nav: true,
			slideBy: 1,
			dots: false,
			margin: 2,
			responsive: {
				1500: {
					items: 5,
				},
				1320 : {
					items: 4,
				},
				1080 : {
					items: 3,
				},
				880 : {
					items: 3,
				},
				576 : {
					items: 2,
				},
				0: {
					items: 1,
				}
			},
			navText: ["", ""],
		});

		site.owl.init('.icon__box', {
			items: 1,
			loop: false,
			nav: true,
			slideBy: 1,
			dots: false,
			responsive: {
				1500: {
					items: 6,
				},
				1320 : {
					items: 5,
				},
				880 : {
					items: 4,
				},
				576 : {
					items: 3,
				},
				400 : {
					items: 2,
				},
				0: {
					items: 1,
				}
			},
			navText: ["", ""],
		});

		site.owl.init('.schools .items', {
			loop: true,
			nav: true,
			dots:false,
			margin:0,
			autoHeight: true,
			startPosition:2,
			center:true,
			navText:["<i class=\"fa fa-angle-left\" />","<i class=\"fa fa-angle-right\" />"],
			items: 1
		});

		site.owl.init('.innaCardList', {
			items: 1,
			loop: false,
			nav: true,
			margin: 30,
			slideBy: 1,
			dots: false,
			responsive: {
				1500: {
					items: 4,
				},
				1200 : {
					items: 3,
				},
				768 : {
					items: 2,
				},
				400 : {
					items: 1,
				}
			},
			navText: ["", ""],
		});
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();

		window.onload = function(event) {
			const buttons = document.querySelectorAll('#closeMenu');
			buttons.forEach(function(button) {
				button.addEventListener('click', function(event) {
					$('body').removeClass('mainmenu-open');
					const level1 = document.querySelectorAll('#mainmenu .mmLevel1 .level1.children.open');
					level1.forEach(function(el) {
						el.classList.remove('open');
					});
				})
			});
		}
	});

	site.accessibility.init();
	site.svg.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
